var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row flex-grow" }, [
    _c("div", { staticClass: "col-lg-7 mx-auto text-white" }, [
      _c("div", { staticClass: "row align-items-center d-flex flex-row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-lg-6 error-page-divider text-lg-left pl-lg-4" },
          [
            _c("h2", [_vm._v(_vm._s(_vm.$t("errors.404.sorry")))]),
            _vm._v(" "),
            _c("h3", { staticClass: "font-weight-light" }, [
              _vm._v(_vm._s(_vm.$t("errors.404.page_not_found")))
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-5" }, [
        _c(
          "div",
          { staticClass: "col-12 text-center mt-xl-2" },
          [
            _c(
              "router-link",
              {
                staticClass: "text-white font-weight-medium",
                attrs: { to: { name: "locker.get-aform" } }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("errors.404.back_to_home")) +
                    "\n                "
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-5" }, [
        _c("div", { staticClass: "col-12 mt-xl-2" }, [
          _c(
            "p",
            { staticClass: "text-white font-weight-medium text-center" },
            [
              _vm._v(
                "\n                    Copyright © " +
                  _vm._s(new Date().getFullYear()) +
                  ". All rights reserved.\n                "
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-6 text-lg-right pr-lg-4" }, [
      _c("h1", { staticClass: "display-1 mb-0" }, [_vm._v("404")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }